const Container = () => import('@/views/Container.vue');

const Routes = [
  {
    path: '/',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/risk',
    component: Container,
    children: [
      {
        path: '',
        component: () => import('@/views/Risk/RiskStart.vue'),
      },
      {
        path: 'risking',
        component: () => import('@/views/Risk/Risking.vue'),
      },
      {
        path: 'confirm',
        component: () => import('@/views/Risk/Confirm.vue'),
      },
      {
        path: 'result',
        component: () => import('@/views/Risk/Result.vue'),
      },
    ],
  },
  {
    path: '/natural',
    component: Container,
    children: [
      {
        path: '',
        component: () => import('@/views/NaturalPersonInvestor/BaseInfo.vue'),
      },
      {
        path: 'questions',
        component: () => import('@/views/NaturalPersonInvestor/Questions.vue'),
      },
    ],
  },
  {
    path: '/corporate',
    component: Container,
    children: [
      {
        path: '',
        component: () => import('@/views/CorporateInvestor/BaseInfo.vue'),
      },
      {
        path: 'legal',
        component: () => import('@/views/CorporateInvestor/LegalInfo.vue'),
      },
      {
        path: 'manager',
        component: () => import('@/views/CorporateInvestor/ManagerInfo.vue'),
      },
      {
        path: 'questions',
        component: () => import('@/views/CorporateInvestor/Questions.vue'),
      },
    ],
  },
  {
    path: '/product',
    component: Container,
    children: [
      {
        path: '',
        component: () => import('@/views/ProductInvestor/BaseInfo.vue'),
      },
      {
        path: 'legal',
        component: () => import('@/views/ProductInvestor/LegalInfo.vue'),
      },
      {
        path: 'manager',
        component: () => import('@/views/ProductInvestor/ManagerInfo.vue'),
      },
      {
        path: 'questions',
        component: () => import('@/views/ProductInvestor/Questions.vue'),
      },
    ],
  },
  {
    path: '/guide',
    component: Container,
    children: [
      {
        path: '',
        component: () => import('@/views/Guide/Index.vue'),
      },
      {
        path: 'register',
        component: () => import('@/views/Guide/Register.vue'),
      },
      {
        path: 'specific',
        component: Container,
        children: [
          {
            path: '',
            component: () => import('@/views/Guide/Specific/Index.vue'),
          },
          {
            path: 'natural/one',
            component: () => import('@/views/Guide/Specific/NaturalOne.vue'),
          },
          {
            path: 'natural/two',
            component: () => import('@/views/Guide/Specific/NaturalTwo.vue'),
          },
          {
            path: 'natural/three',
            component: () => import('@/views/Guide/Specific/NaturalThree.vue'),
          },
          {
            path: 'corporate/one',
            component: () => import('@/views/Guide/Specific/CorporateOne.vue'),
          },
          {
            path: 'corporate/two',
            component: () => import('@/views/Guide/Specific/CorporateTwo.vue'),
          },
          {
            path: 'corporate/three',
            component: () => import('@/views/Guide/Specific/CorporateThree.vue'),
          },
          {
            path: 'corporate/four',
            component: () => import('@/views/Guide/Specific/CorporateFour.vue'),
          },
        ],
      },
      {
        path: 'processApply',
        component: () => import('@/views/Guide/ProcessApply.vue'),
      },
      {
        path: 'processConfirm',
        component: () => import('@/views/Guide/ProcessConfirm.vue'),
      },
      {
        path: 'contractSign',
        component: () => import('@/views/Guide/ContractSign.vue'),
      },
      {
        path: 'relation',
        component: () => import('@/views/Guide/Relation.vue'),
      },
      {
        path: 'auth',
        component: () => import('@/views/Guide/Auth.vue'),
      },
      {
        path: 'risk',
        component: () => import('@/views/Guide/Risk.vue'),
      },
      {
        path: 'reserve',
        component: () => import('@/views/Guide/Reserve.vue'),
      },
      {
        path: 'order',
        component: () => import('@/views/Guide/Order.vue'),
      },
      {
        path: 'recorde',
        component: () => import('@/views/Guide/Recorde.vue'),
      },
      {
        path: 'sign',
        component: () => import('@/views/Guide/Sign.vue'),
      },
      {
        path: 'orderState',
        component: () => import('@/views/Guide/OrderState.vue'),
      },
      {
        path: 'password',
        component: () => import('@/views/Guide/Password.vue'),
      },
    ],
  },
  {
    path: '/privacy',
    component: () => import('@/views/Privacy/Index.vue'),
  },
  {
    path: '/register',
    component: () => import('@/views/Register/Index.vue'),
  },
  {
    path: '/protocol',
    component: () => import('@/views/Protocol/Index.vue'),
  },
  {
    path: '/download',
    component: () => import('@/views/Download/Index.vue'),
  },
  {
    path: '/tax',
    component: () => import('@/views/Tax/Tax.vue'),
    children: [
      {
        path: 'personal',
        component: () => import('@/views/Tax/TaxPersonal.vue'),
      },
      {
        path: 'org',
        component: () => import('@/views/Tax/TaxOrg.vue'),
      },
    ],
  },
  {
    path: '/xinguan',
    component: () => import('@/views/0214/Index.vue'),
  },
  {
    path: '/verifiy/:sealId', // 数字证书申请验证
    component: () => import('@/views/DigitalCertificateVerification/DigitalCertificateVerification.vue'),
  },
];

export default Routes;
